import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackEvent, Events } from '../lib/fpixel';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    let scrollPercentages = new Set();
    
    const handleScroll = () => {
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrolled = window.scrollY;
      const scrollPercentage = Math.round((scrolled / scrollHeight) * 100);

      // Track at 25%, 50%, 75%, and 90% scroll depth
      const thresholds = [25, 50, 75, 90];
      
      thresholds.forEach(threshold => {
        if (scrollPercentage >= threshold && !scrollPercentages.has(threshold)) {
          scrollPercentages.add(threshold);
          
          trackEvent(Events.SCROLL, {
            percent_scrolled: threshold,
            page_path: pathname,
            content_name: document.title
          });
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [pathname]);

  return null;
};

export default ScrollToTop; 